import { render, staticRenderFns } from "./PrecintoEstado.vue?vue&type=template&id=745588ba"
import script from "./PrecintoEstado.vue?vue&type=script&lang=js"
export * from "./PrecintoEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports